import styled from "styled-components";

export const Title = styled.h2`
	margin: 1rem;
`;

export const ContainerFeatures = styled.div`
	display: flex;
	width: 100%;
	@media (min-width: 320px) {
		flex-wrap: wrap;
	}
`;
